import { LINK_PURPOSES } from '@identity/domain/types';
import type { LinkPurpose } from '@identity/domain/types';

import { PASSWORD_RESET_ROUTE } from './routes';

/**
 * The route each link purpose redirects to after a successful consume.
 *
 * It is a complete `Record`, so adding a purpose fails to compile until it has a route and the value
 * sent by the server is never joined into a path. The two verification purposes end on sibling
 * paths, so the confirmation screen names the channel it verified and still does after a reload.
 */
export const LINK_PURPOSE_ROUTES: Record<LinkPurpose, string> = {
  invitation: '/auth/activate',
  verify_email: '/auth/verified/email',
  verify_phone: '/auth/verified/phone',
  recover: PASSWORD_RESET_ROUTE,
};

/**
 * Whether a string sent by the server is a purpose this build knows.
 *
 * It checks the list and not the keys of the record, because indexing a record would also find
 * inherited properties and accept a purpose named `constructor`.
 */
const isLinkPurpose = (value: string): value is LinkPurpose => (LINK_PURPOSES as readonly string[]).includes(value);

/** The route for a purpose reported by the server, or `null`: an unknown one is never guessed. */
export const resolveLinkPurposeRoute = (purpose: string): string | null =>
  isLinkPurpose(purpose) ? LINK_PURPOSE_ROUTES[purpose] : null;
